const Data = [
    {
        "srno": 1,
        "question": "Is there a free trial available?",
        "answer": `Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.`

    }, {
        "srno": 2,
        "question": "Can I change my plan later?",
        "answer": `Yes, you can change your subscription plan anytime from your account settings.`

    }, {
        "srno": 3,
        "question": "What is your cancellation policy?",
        "answer": `You can cancel your subscription anytime, and it will remain active until the end of the billing cycle.`

    }, {
        "srno": 4,
        "question": "Can other info be added to an invoice?",
        "answer": `Yes, please contact support to add custom information to your invoice.`

    }
    , {
        "srno": 5,
        "question": "How does billing work?",
        "answer": `Billing is processed monthly or annually, depending on your selected plan.`

    },
    {
        "srno": 6,
        "question": "How do I change my account email?",
        "answer": `You can update your account email in the settings section of your profile.`

    }

]
 export default Data